import getServerIntl from '../lib/intl';

if (typeof window !== 'undefined' && process.env['NODE_ENV'] !== 'test')
  // eslint-disable-next-line no-console
  console.error(
    "Warning: This component should only be used with server components. Either this, or a parent component is marked with 'use client'.",
  );

export type FormattedMessageProps = {
  id: string;
  defaultMessage: string;
  values?: Record<string, any>;
};

/**
 * Represents a formatted message.
 * @param {Object} props - The props object.
 * @param {string} props.id - The message ID.
 * @param {string} props.defaultMessage - The default message.
 * @returns {string} - The formatted message.
 */
export default function FormattedMessage({
  id,
  defaultMessage,
  values,
}: FormattedMessageProps) {
  const intl = getServerIntl();

  return intl.formatMessage({ id, defaultMessage }, values);
}
